module.exports = __webpack_public_path__ + "img/icon_customer_add_filter.svg";